<template>
  <default-layout :validate="validate">
    <router-view :regresavalor="regresavalors"></router-view>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout'
export default {
  name: 'Profile',
  props: {
    regresavalor: {
      type: Function
    }
  },
  data () {
    return {
      validate: 'rtytyutyu'
    }
  },
  updated () {
    this.validate = 'rtytyutyu'
  },
  methods: {
    regresavalors () {
      this.validate = 'segments'
    }
  },
  components: {
    DefaultLayout
  }
}
</script>
